import { NotEditable } from '../../../components/NotEditable';
import styled from 'styled-components';
import { Colors } from 'styles';
import { useSelected } from '../../../core/index';
import { forwardRef } from 'react';
import type { SectionHeaderPluginElement } from '../types';
import { rootTheme } from 'theme/rootTheme';

type SectionHeaderProps = {
  element: SectionHeaderPluginElement;
  children: React.ReactNode;
};

const RenderableComponent = styled(NotEditable)<{ selected: boolean }>`
  padding: 2px 4px;
  vertical-align: baseline;
  border-radius: ${rootTheme.radius.xs}px;
  background: ${Colors.teal2};
  z-index: ${(props) => (props.selected ? 10 : 0)};
  color: ${(props) => (props.selected ? Colors.blue6 : Colors.white)};
  cursor: pointer;
  box-shadow: ${(props) => (props.selected ? `0 0 0 1px ${Colors.blue6}` : 'none')};
  &:after {
    content: ':';
  }
`;

const SectionHeaderComponent = forwardRef<HTMLSpanElement, SectionHeaderProps>((props, ref) => {
  const selected = useSelected();
  return (
    <RenderableComponent ref={ref} selected={selected}>
      {props.children}
    </RenderableComponent>
  );
});
SectionHeaderComponent.displayName = 'SectionHeaderComponent';

export const SectionHeader = SectionHeaderComponent;
export const SectionHeaderRenderer = SectionHeaderComponent;
